module.exports = __webpack_public_path__ + "static/media/image_case_shitang.701aef19.png";